import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Modal from 'react-modal';
import getModalStyling from '../../../../../shared/utils/ModalUtils';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';


const CompanyReportingFailedModal = (props) => {
    const { isOpen, onSubmit, type } = props;

    const handleSubmit = () => {
        onSubmit(type);
    };

    return (
        <Modal
            className={cns('verb-modal admin-to-users-email-modal admin-modal')}
            style={getModalStyling({ content: { width: '450px' } })}
            isOpen={isOpen}
            contentLabel={'Modal'}
        >
            <div className={'baseModal main-panel grid'}>
                <br />
                <div className={'row'}>
                    <div>
                 We're sorry, there was an error with this link. Please try the link again or request a new report.
                 <br /><br /></div>
                    <div>
                 If you need additional help, ask an authorized contact to submit a work order to Paycor.
                    <br />
                    </div>
                </div>
                    <div className={'row'}>
                        <div className={'col-6 cr_bottom_panel cr_col_panel'}>
                        <VerbButton
                            className={'cr_go_back'}
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            defaultMessage={'GO BACK'}
                            onClick={() => handleSubmit()}
                            type={'button'}
                            buttonText = {'GO BACK'}
                            
                        /></div>   <div className={'col-6 cr_bottom_panel'}>
                        <VerbButton
                            className={'ms-auto submit-button cr_submit'}
                            type={'submit'}
                            defaultMessage={'NEW REPORT'}
                            onClick={() => handleSubmit(type)}
                            buttonText = {'NEW REPORT'}
                        /></div>
                    </div>
                </div>
        </Modal>
    );
};

CompanyReportingFailedModal.propTypes = {
    isOpen: PropTypes.bool,
    onSubmit: PropTypes.func
};

export default CompanyReportingFailedModal;
